module.exports = __webpack_public_path__ + "static/media/afl_everyday_digital.29b7d1ce.webp";